/* eslint-disable */
export default {
  flipHeader: 'Traspasar la llamada a...',
  flip: 'Transferir',
  complete: 'Completar traspaso',
} as const;

// @key: @#@"flipHeader"@#@ @source: @#@"Flip Call to..."@#@
// @key: @#@"flip"@#@ @source: @#@"Flip"@#@
// @key: @#@"complete"@#@ @source: @#@"Complete Flip"@#@
